import React from "react";
import { useQuery } from "@apollo/client";
import { gql } from "graphql-tag";
import moment from "moment";
import { RouteComponentProps } from "@reach/router";
import { ServerError, LoadingSpinner } from "components/graphql-views";
import { ContainerCardLayout } from "components/haven-design";
import MessageTable from "./messages-table";

const ERROR_TYPE = "ERROR";
const MESSAGE_ERRORS = gql`
  query messageErrors($type: String) {
    messages(type: $type) {
      id
      insertedAt
      status
      recipientName
      interestUrl
      subject
      emailToAddress
      mobileNumber
      bodyPreview
    }
  }
`;

interface Message {
  id: string;
  insertedAt: string;
  status: string;
  recipientName: string;
  interestUrl: string;
  subject: string;
  emailToAddress: string;
  mobileNumber: string;
  bodyPreview: string;
}

interface QueryData {
  messages: Message[];
}
const formatData = (messages: Message[]) => messages.map((msg) => ({
  createdAt: moment(`${msg.insertedAt}Z`).format("M/D/YY - h:mm A"),
  interestUrl: msg.interestUrl,
  type: msg.emailToAddress ? "Email" : "SMS",
  recipientName: msg.recipientName.trim() || "N/A",
  subject: msg.subject || "N/A",
  statusMessage: msg.status,
  body: msg.bodyPreview || "N/A",
}));

const Messages: React.FC<RouteComponentProps> = () => {
  const { loading, error, data } = useQuery<QueryData>(MESSAGE_ERRORS, {
    fetchPolicy: "cache-first",
    variables: { type: ERROR_TYPE },
  });

  return (
    <ContainerCardLayout title="Failed Messages">
      {error && <ServerError desc={error.message} />}
      {loading && <LoadingSpinner />}
      <div style={{ display: "grid" }}>
        <div style={{ overflowX: "auto" }}>
          {(!error && !loading) && (data ? (
            <MessageTable rowData={formatData(data.messages)} />) : (
            <ServerError desc="Missing Data" />))}
        </div>
      </div>
    </ContainerCardLayout>
  );
};

export default Messages;
